// extracted by mini-css-extract-plugin
export default {"main":"Button_main__B95NL","secondary":"Button_secondary__xIDl+","small":"Button_small__Dg2wq"};